<div class="w-full flex flex-col gap-4 p-4">
    <h1 class="text-2xl font-bold">Lista de Clientes TOQSYS</h1>

    <div
        class="w-full grid md:grid-cols-3 grid-cols-1 lg:gap-x-20 gap-4 items-end"
    >
        <app-select
            [icon]="true"
            (onValueChange)="revenda($event)"
            [options]="selectedRevenda"
            label="Revenda"
        ></app-select>

        <app-select
            [icon]="true"
            (onValueChange)="contador($event)"
            [options]="selectedContador"
            label="Contador"
        ></app-select>

        <app-select
            [icon]="true"
            (onValueChange)="holding($event)"
            [options]="selectedHolding"
            label="Holding"
        ></app-select>

        <!-- Pesquisar Empresa -->
        <!-- <div class="w-full flex items-end gap-1">
            <app-input
                [(ngModel)]="filtro"
                label="Pesquisar Empresa"
                (keydown.enter)="filter()"
                class="flex-1"
            ></app-input>

            <button
                class="bg-primary text-white h-8 aspect-square cursor-pointer rounded-md hover:bg-primary-hover transition-all duration-300 flex items-center justify-center"
                (click)="filter()"
            >
                <i class="fa fa-search"></i>
            </button>
        </div> -->

        <app-input-search
            [(ngModel)]="filtro"
            label="Pesquisar Empresa"
            (keydown.enter)="filter()"
            (search)="filter()"
            class="flex-1"
        ></app-input-search>

        <app-select
            class="p-col-3"
            [icon]="true"
            (onValueChange)="statuss($event)"
            [options]="status"
            label="Status"
        ></app-select>

        <div class="w-full flex items-end gap-4 md:justify-end justify-evenly">
            <div
                class="cursor-pointer h-8 aspect-square bg-white flex justify-center items-center rounded-md shadow-md"
            >
                <i class="fa fa-file-excel-o text-green-500!"></i>
            </div>

            <div
                class="cursor-pointer h-8 aspect-square bg-white flex justify-center items-center rounded-md shadow-md"
            >
                <i class="fa fa-file-pdf-o text-red-500!"></i>
            </div>
        </div>
    </div>

    <p-table
        [paginator]="true"
        [rows]="qtdLinhas || 7"
        [totalRecords]="totalItens"
        (onPage)="paginator($event)"
        [value]="lista"
        [lazy]="true"
    >
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="w-[25%] min-w-10">Empresa</th>
                <th class="w-[25%] min-w-10">Cnpj</th>
                <th class="w-[10%] min-w-10">Revenda</th>
                <th class="w-[10%] min-w-10">Telefone</th>
                <th class="w-[20%] min-w-10">email</th>
                <th class="w-[5%] min-w-10">Status</th>
                <th class="w-[5%] min-w-10">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr>
                <td>{{ rowData.RAZAO_SOCIAL }}</td>
                <td>{{ rowData.CPF_CNPJ | cpfCnpj }}</td>
                <td>{{ rowData.NOME_BANCO }}</td>
                <td>{{ rowData.TELEFONE | telefone }}</td>
                <td>{{ rowData.EMAIL }}</td>
                <td>{{ rowData.STATUS }}</td>
                <td>
                    <app-opcoes-table
                        [value]="rowData"
                        [opcoes]="opcoesTable"
                    ></app-opcoes-table>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<!-- <div class="p-grid">
   
            <div
                class="p-field p-col-12 p-md-3"
                style="
                    font-size: 18px;
                    margin-top: 25px;
                    display: flex;
                    justify-content: flex-end;
                "
            >
                
                <i
                    class="fa fa-file-pdf"
                    style="margin-left: 15px; cursor: pointer"
                ></i>
            </div>
        </div>
        
    </div>
</div> -->
